<template>
  <v-list-item class="ferro-menu-item" :class="{ 'is-selected': isSelected }" @click="$emit('click')">
    <v-list-item-icon>
      <div class="component-icon" v-if="componentIcon">
        <icon :icon="componentIcon" />
      </div>
      <v-icon v-else>{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
        {{ title }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
import Icon from '@/assets/icons/Icon.vue'

export default {
  components: {
    Icon,
  },
  props: {
    isSelected: { type: Boolean, required: false, default: false },
    componentIcon: { type: String, required: false, default: null },
    icon: { type: String, required: false, default: null },
    title: { type: String, required: true },
  },
}
</script>
<style scoped lang="scss">
.theme--light.v-icon {
  color: var(--color-more-darker);
}

a {
  text-decoration: none;
}
.ferro-menu-item {
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
.component-icon {
  position: absolute;
  left: 8px;
  top: 8px;
  width: 24px;
  filter: grayscale(1);
  opacity: 0.5;
}
.ferro-menu-item.is-selected {
  background-color: color-mix(in srgb, var(--color-primary) 15%, transparent);

  .component-icon {
    filter: initial;
    opacity: 1;
  }

  .v-list-item__icon {
    .theme--light.v-icon {
      color: var(--color-primary);
    }
  }

  .v-list-item__content {
    .v-list-item__title {
      font-weight: bold;
      .theme--light.v-icon {
        color: var(--color-primary);
      }
    }
  }
}
</style>
